/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerListArticleResponse } from "./BlogManagerListArticleResponse";

export type BlogManagerListArticleResponseApiRespoonse = {
  data?: BlogManagerListArticleResponse;
  status?: BlogManagerListArticleResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace BlogManagerListArticleResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
